<script>
	import TextInput from "../../../components/TextInput.svelte";
	import DeleteButton from "../../../components/buttons/DeleteButton.svelte";
	import AddButton from "../../../components/buttons/AddButton.svelte";

	// props
	export let children = [];
	export let label = null;
	export let disabled = null;

	if (!children || !children.length) {
		children = [{}];
	}

	const deleteChild = (i) => {
		children.splice(i, 1);
		children = [...children];
	};

	const addChild = () => {
		children = [...children, {}];
	};
</script>

<div class="wrapper">
	<table>
		<colgroup>
			<col style="width: 96%;" />
			<col style="width: 4%;" />
		</colgroup>
		<thead>
			<tr>
				<th>{@html label}</th>
				<th></th>
			</tr>
		</thead>
		<tbody>
			{#each children as child, i}
				<tr>
					<td>
						<TextInput maxlength="1000" {disabled} bind:value={child.childName} />
					</td>
					<td>
						{#if children.length > 1 && !disabled}
							<DeleteButton title="Remove this child" on:delete={() => deleteChild(i)}></DeleteButton>
						{/if}
					</td>
				</tr>
			{/each}
		</tbody>
	</table>
</div>

<div class="add confirmation-hide">
	<AddButton on:add={addChild}>Add another child</AddButton>
</div>

<style>
	div.wrapper {
		margin-top: 36px;
		padding: 10px;
		background-color: #fff;
	}

	div.add {
		text-align: end;
		margin-top: 10px;
	}

	table {
		width: 100%;
		border-collapse: collapse;
	}

	th,
	td {
		padding: 8px;
	}
</style>
